<template>
  <div class="adm-users">
    <div class="adm-users-header">
      <div>
        <h2 class="adm-users-title">
          <feather-icon icon="UsersIcon" size="22" class="mr-75" />
          Usuários & Clientes
        </h2>
        <p class="adm-users-sub">Gerencie usuários, clientes, pagamentos e permissões da plataforma</p>
      </div>
    </div>

    <div class="adm-users-tabs">
      <button
        v-for="tab in tabs"
        :key="tab.key"
        class="adm-users-tab"
        :class="{ 'adm-users-tab--active': activeTab === tab.key }"
        @click="activeTab = tab.key"
      >
        <feather-icon :icon="tab.icon" size="14" class="mr-50" />
        {{ tab.label }}
      </button>
    </div>

    <div class="adm-users-content">
      <UsersList v-if="activeTab === 'usuarios'" />
      <ListaClientes v-if="activeTab === 'clientes'" />
      <Pagamentos v-if="activeTab === 'pagamentos'" />
      <Permissoes v-if="activeTab === 'permissoes'" />
    </div>
  </div>
</template>

<script>
import UsersList from '../Usuarios/usuarios-lista/UsersList.vue'
import ListaClientes from './Overview/Index.vue'
import Pagamentos from '../Pagamentos/Index.vue'
import Permissoes from './Permissoes/Index.vue'

export default {
  name: 'AdminUsuarios',
  components: { UsersList, ListaClientes, Pagamentos, Permissoes },
  data() {
    return {
      activeTab: this.$route.query.tab || 'usuarios',
      tabs: [
        { key: 'usuarios', label: 'Usuários', icon: 'UserIcon' },
        { key: 'clientes', label: 'Clientes', icon: 'BriefcaseIcon' },
        { key: 'pagamentos', label: 'Pagamentos', icon: 'CreditCardIcon' },
        { key: 'permissoes', label: 'Permissões', icon: 'ShieldIcon' },
      ],
    }
  },
  watch: {
    activeTab(val) {
      if (this.$route.query.tab !== val) {
        this.$router.replace({ query: { ...this.$route.query, tab: val } }).catch(() => {})
      }
    },
  },
}
</script>

<style lang="scss" scoped>
$orange: #E86A10;

.adm-users { padding: 0; }

.adm-users-header {
  margin-bottom: 24px;
}
.adm-users-title {
  display: flex;
  align-items: center;
  font-size: 22px;
  font-weight: 800;
  color: #e2e8f0;
  margin: 0 0 4px;
}
.adm-users-sub {
  font-size: 13.5px;
  color: rgba(255,255,255,0.4);
  margin: 0;
}

.adm-users-tabs {
  display: flex;
  gap: 6px;
  margin-bottom: 24px;
  flex-wrap: wrap;
  border-bottom: 2px solid rgba(255,255,255,0.08);
  padding-bottom: 0;
}
.adm-users-tab {
  display: inline-flex;
  align-items: center;
  padding: 10px 18px;
  border: none;
  background: none;
  color: rgba(255,255,255,0.45);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border-bottom: 2.5px solid transparent;
  margin-bottom: -2px;
  transition: all .18s;
  border-radius: 0;

  &:hover { color: $orange; }
  &--active {
    color: $orange;
    border-bottom-color: $orange;
  }
}

.adm-users-content {
  min-height: 400px;
}
</style>
